<!-- section header -->
<ng-container *ngIf="!!sectionHeader">
  <div [id]="sanitizedTitle" [dot-debug-content]="sectionHeader">
    <div
      *ngIf="
        !!sectionHeader.title ||
        !!sectionHeader.content ||
        sectionHeader.subtitle
      "
      class="jb-max-width center"
    >
      <div
        [ngClass]="{
          mt0: sectionHeader.removeSectionSpacing,
          'mt7-l mt6': !sectionHeader.removeSectionSpacing,
          'mb4 mb5-ns': !list,
          'justify-center grid-offset-m': centerAligned,
          'grid-offset-l': !centerAligned,
          'mb3 mb4-ns': list
        }"
        class="jb-grid one-up center gr-unset"
      >
        <div
          [ngClass]="{
            'tc col-10-m-temp': centerAligned,
            'bb b--light-gray': list
          }"
        >
          <h2
            class="flex flex-column"
            [ngClass]="{
              mb0: !sectionHeader.content
            }"
            tabindex="-1"
          >
            <div>
              <span
                *ngIf="sectionHeader.subtitle"
                class="mb1 ttu klarheit s-body db h5-letter-spacing"
                [ngClass]="
                  sectionHeader.theme === 'dark' ? 'white' : 'charcoal'
                "
              >
                {{ sectionHeader.subtitle }}
              </span>
              <span
                *ngIf="!!sectionHeader.title"
                [ngClass]="
                  sectionHeader.theme === 'dark' ? 'white' : 'core-blue'
                "
              >
                {{ sectionHeader.title }}
              </span>
            </div>
          </h2>
          <p
            *ngIf="sectionHeader.content"
            class="mb0 klarheit lh-copy"
            [ngClass]="{
              tc: centerAligned,
              charcoal: !sectionHeader.theme || sectionHeader.theme === 'light',
              white: sectionHeader.theme === 'dark'
            }"
          >
            {{ sectionHeader.content }}
          </p>
          <ng-container
            *ngIf="
              sectionHeader.appStoreLogo && sectionHeader.appStoreLogo.length
            "
            ><jb-app-store
              [content]="sectionHeader.appStoreLogo[0]?.data?.logos"
            ></jb-app-store
          ></ng-container>
        </div>
      </div>
    </div>

    <!-- various elements within section -->
    <ng-container
      *ngIf="!!sectionHeader.section && !!sectionHeader.section.length"
    >
      <div class="center" [ngClass]="getSectionClass()">
        <jb-renderer-template
          *ngIf="components && registry"
          class="w-100"
          [components]="components"
          [registry]="registry"
          [priority]="'secondary'"
        ></jb-renderer-template>
      </div>
    </ng-container>

    <!-- Family Brand Block - automatically rendered when familyBlock data is present -->
    <ng-container
      *ngIf="sectionHeader.familyBlock && sectionHeader.familyBlock.length"
    >
      <div class="center">
        <jb-family-brand-block
          [header]="sectionHeader.familyBlock[0]?.data?.header || ''"
          [familyBlocks]="
            getFamilyBlocks(
              sectionHeader.familyBlock[0]?.data?.familyBlocks || []
            )
          "
        ></jb-family-brand-block>
      </div>
    </ng-container>
  </div>
</ng-container>
